import { authDebug, startSignon } from '../lib'

export function doSignOnFederated({
  state,
  status,
  type,
  authResponse,
  dispatch
}) {
  authDebug(1, '[Signon].doSignOnFederated()')
  return startSignon({
    state,
    status,
    vars: {
      type: type,
      data: { auth: authResponse }
    },
    dispatch
  })
}
